module.exports = __webpack_public_path__ + "assets/fonts/GothamPro.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/gothampro/GothamPro.eot
// module id = 449
// module chunks = 0